module.exports = __webpack_public_path__ + "static/hohe-bonbon-dose_1.3c83d4e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/hohe-bonbon-dose_1.jpg
// module id = 558
// module chunks = 35783957827783